let timeout = null

/**
 * author:caipengcheng
 * 防抖原理：一定时间内，只有最后一次操作，再过wait毫秒后才执行函数
 *
 * @param {Function} func 要执行的回调函数
 * @param {Number} wait 延时的时间
 * @return null
 */
function debounce(func, wait = 500) {
  console.log('timeout', timeout);
  // 清除定时器
  if (timeout !== null) clearTimeout(timeout)
  // 设置定时器，当最后一次操作后，timeout不会再被清除，所以在延时wait毫秒后执行func回调方法
  timeout = setTimeout(() => {
    typeof func === 'function' && func()
  }, wait)

}

export default debounce
